import React from 'react';
import SearchBar from '../../common/SearchBar';
import { useAdminTranslation } from '../../../modules/i18n';

interface UserFilterBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const UserFilterBar: React.FC<UserFilterBarProps> = ({ searchQuery, onSearchChange }) => {
  const { t } = useAdminTranslation();

  return (
    <SearchBar
      value={searchQuery}
      onChange={onSearchChange}
      placeholder={t('content.users.filters.searchPlaceholder')}
      className='sm:max-w-sm'
    />
  );
};

export default UserFilterBar;
